export default "__VITE_ASSET__c066afcd__"